import { DetailedHTMLProps, InputHTMLAttributes, useState } from 'react'
import { RadioContainer, RadioInput, RadioWrapper } from './radio.stye'

type Props = {
  options: any[]
  default: string
  inputName: string
  onChange: (event: string) => void
}

export const RadioGroupBtn = ({ options, default: defaultVal, inputName, onChange, ...rest }: Props) => {
  const Input = ({ option }: { option: string }) => {
    const [value, setValue] = useState<boolean>(option === defaultVal)
    return (
      <RadioWrapper style={{ display: 'flex' }}>
        <RadioInput
          defaultChecked={value}
          id={option}
          name={inputName}
          onChange={event => {
            setValue(event.target.checked)
            onChange(option)
          }}
          type="radio"
          {...rest}
        />
        <label htmlFor={option}>{option}</label>
      </RadioWrapper>
    )
  }

  return (
    <RadioContainer>
      {options?.map(option => (
        <Input key={option} option={option} />
      ))}
    </RadioContainer>
  )
}

export const RadioBtn = (props: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => {
  return <RadioInput type="radio" {...props} />
}
